/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApprovalContractDto,
  CompleteSigningRequest,
  ContractDetails,
  ContractDtoPagination,
  ContractTableRequest,
  ContractTrackingTimelineDto,
  ContractTrackingWorkflowDto,
  CreateContractTrackingRequest,
  GetApprovalContractsParams,
  GetAvailableContractTrackingWorkflowsParams,
  GetContractDetailsParams,
  GetContractTrackingWorkflowStepsParams,
  ProfileContract,
  SendNotificationsAndEmailsParams,
  SetDeadlineRequest,
  StartSigningRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetProfileContractsUrl = () => {




  return `/api/Contracts/GetProfileContracts`
}

export const getProfileContracts = async ( options?: Parameters<typeof customInstance>[1]): Promise<ProfileContract[]> => {

  return customInstance<ProfileContract[]>(getGetProfileContractsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfileContractsQueryKey = () => {
    return [
    `/api/Contracts/GetProfileContracts`
    ] as const;
    }


export const getGetProfileContractsQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContractsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContracts>>> = ({ signal }) => getProfileContracts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContracts>>>
export type GetProfileContractsQueryError = ErrorType<unknown>


export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof getProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfileContracts<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileContractsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProfileContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileContractsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileContracts>>> = ({ signal }) => getProfileContracts({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProfileContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileContracts>>>
export type GetProfileContractsSuspenseQueryError = ErrorType<unknown>


export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof getProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileContractsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedContractsUrl = () => {




  return `/api/Contracts/GetPaginatedContracts`
}

export const getPaginatedContracts = async (contractTableRequest: ContractTableRequest, options?: Parameters<typeof customInstance>[1]): Promise<ContractDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ContractDtoPagination>(getGetPaginatedContractsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contractTableRequest)
  }
);}





export const getGetPaginatedContractsMutationKey = () => ['getPaginatedContracts'] as const;

export const getGetPaginatedContractsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedContracts>>, TError,GetPaginatedContractsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedContracts>>, TError,GetPaginatedContractsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedContractsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedContracts>>, GetPaginatedContractsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedContracts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedContractsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedContracts>>>
    export type GetPaginatedContractsMutationBody = BodyType<ContractTableRequest>
    export type GetPaginatedContractsMutationError = ErrorType<unknown>
    export type GetPaginatedContractsMutationVariables = {data: BodyType<ContractTableRequest>}

    export const useGetPaginatedContracts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedContracts>>, TError,GetPaginatedContractsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedContracts>>,
        TError,
        GetPaginatedContractsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedContractsMutationOptions(options), queryClient);
    }
    export const getGetContractDetailsUrl = (params?: GetContractDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractDetails?${stringifiedParams}` : `/api/Contracts/GetContractDetails`
}

export const getContractDetails = async (params?: GetContractDetailsParams, options?: Parameters<typeof customInstance>[1]): Promise<ContractDetails> => {

  return customInstance<ContractDetails>(getGetContractDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContractDetailsQueryKey = (params?: GetContractDetailsParams,) => {
    return [
    `/api/Contracts/GetContractDetails`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetContractDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractDetails>>> = ({ signal }) => getContractDetails(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getContractDetails>>>
export type GetContractDetailsQueryError = ErrorType<unknown>


export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractDetails>>,
          TError,
          Awaited<ReturnType<typeof getContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractDetails>>,
          TError,
          Awaited<ReturnType<typeof getContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractDetails<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetContractDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractDetails>>> = ({ signal }) => getContractDetails(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetContractDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractDetails>>>
export type GetContractDetailsSuspenseQueryError = ErrorType<unknown>


export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetContractDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof getContractDetails>>, TError = ErrorType<unknown>>(
 params?: GetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractDetailsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApprovalContractsUrl = (params?: GetApprovalContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetApprovalContracts?${stringifiedParams}` : `/api/Contracts/GetApprovalContracts`
}

export const getApprovalContracts = async (params?: GetApprovalContractsParams, options?: Parameters<typeof customInstance>[1]): Promise<ApprovalContractDto[]> => {

  return customInstance<ApprovalContractDto[]>(getGetApprovalContractsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApprovalContractsQueryKey = (params?: GetApprovalContractsParams,) => {
    return [
    `/api/Contracts/GetApprovalContracts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApprovalContractsQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalContractsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalContracts>>> = ({ signal }) => getApprovalContracts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApprovalContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalContracts>>>
export type GetApprovalContractsQueryError = ErrorType<unknown>


export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApprovalContractsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof getApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof getApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApprovalContracts<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApprovalContractsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApprovalContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApprovalContractsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalContracts>>> = ({ signal }) => getApprovalContracts(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetApprovalContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalContracts>>>
export type GetApprovalContractsSuspenseQueryError = ErrorType<unknown>


export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApprovalContractsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof getApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: GetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApprovalContractsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAvailableContractTrackingWorkflowsUrl = (params: GetAvailableContractTrackingWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetAvailableContractTrackingWorkflows?${stringifiedParams}` : `/api/Contracts/GetAvailableContractTrackingWorkflows`
}

export const getAvailableContractTrackingWorkflows = async (params: GetAvailableContractTrackingWorkflowsParams, options?: Parameters<typeof customInstance>[1]): Promise<ContractTrackingWorkflowDto[]> => {

  return customInstance<ContractTrackingWorkflowDto[]>(getGetAvailableContractTrackingWorkflowsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAvailableContractTrackingWorkflowsQueryKey = (params?: GetAvailableContractTrackingWorkflowsParams,) => {
    return [
    `/api/Contracts/GetAvailableContractTrackingWorkflows`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAvailableContractTrackingWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableContractTrackingWorkflowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>> = ({ signal }) => getAvailableContractTrackingWorkflows(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailableContractTrackingWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>>
export type GetAvailableContractTrackingWorkflowsQueryError = ErrorType<unknown>


export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableContractTrackingWorkflows<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableContractTrackingWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAvailableContractTrackingWorkflowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableContractTrackingWorkflowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>> = ({ signal }) => getAvailableContractTrackingWorkflows(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAvailableContractTrackingWorkflowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>>
export type GetAvailableContractTrackingWorkflowsSuspenseQueryError = ErrorType<unknown>


export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailableContractTrackingWorkflowsSuspense<TData = Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError = ErrorType<unknown>>(
 params: GetAvailableContractTrackingWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailableContractTrackingWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailableContractTrackingWorkflowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateContractTrackingUrl = () => {




  return `/api/Contracts/CreateContractTracking`
}

export const createContractTracking = async (createContractTrackingRequest?: CreateContractTrackingRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCreateContractTrackingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createContractTrackingRequest)
  }
);}





export const getCreateContractTrackingMutationKey = () => ['createContractTracking'] as const;

export const getCreateContractTrackingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,CreateContractTrackingMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,CreateContractTrackingMutationVariables, TContext> => {

const mutationKey = getCreateContractTrackingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractTracking>>, CreateContractTrackingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createContractTracking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContractTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof createContractTracking>>>
    export type CreateContractTrackingMutationBody = BodyType<CreateContractTrackingRequest> | undefined
    export type CreateContractTrackingMutationError = ErrorType<unknown>
    export type CreateContractTrackingMutationVariables = {data?: BodyType<CreateContractTrackingRequest>}

    export const useCreateContractTracking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractTracking>>, TError,CreateContractTrackingMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContractTracking>>,
        TError,
        CreateContractTrackingMutationVariables,
        TContext
      > => {
      return useMutation(getCreateContractTrackingMutationOptions(options), queryClient);
    }
    export const getSendNotificationsAndEmailsUrl = (params: SendNotificationsAndEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/SendNotificationsAndEmails?${stringifiedParams}` : `/api/Contracts/SendNotificationsAndEmails`
}

export const sendNotificationsAndEmails = async (params: SendNotificationsAndEmailsParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getSendNotificationsAndEmailsUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendNotificationsAndEmailsMutationKey = () => ['sendNotificationsAndEmails'] as const;

export const getSendNotificationsAndEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,SendNotificationsAndEmailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,SendNotificationsAndEmailsMutationVariables, TContext> => {

const mutationKey = getSendNotificationsAndEmailsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, SendNotificationsAndEmailsMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  sendNotificationsAndEmails(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendNotificationsAndEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotificationsAndEmails>>>

    export type SendNotificationsAndEmailsMutationError = ErrorType<unknown>
    export type SendNotificationsAndEmailsMutationVariables = {params: SendNotificationsAndEmailsParams}

    export const useSendNotificationsAndEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsAndEmails>>, TError,SendNotificationsAndEmailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendNotificationsAndEmails>>,
        TError,
        SendNotificationsAndEmailsMutationVariables,
        TContext
      > => {
      return useMutation(getSendNotificationsAndEmailsMutationOptions(options), queryClient);
    }
    export const getGetContractTrackingWorkflowStepsUrl = (params: GetContractTrackingWorkflowStepsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractTrackingWorkflowSteps?${stringifiedParams}` : `/api/Contracts/GetContractTrackingWorkflowSteps`
}

export const getContractTrackingWorkflowSteps = async (params: GetContractTrackingWorkflowStepsParams, options?: Parameters<typeof customInstance>[1]): Promise<ContractTrackingTimelineDto[]> => {

  return customInstance<ContractTrackingTimelineDto[]>(getGetContractTrackingWorkflowStepsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContractTrackingWorkflowStepsQueryKey = (params?: GetContractTrackingWorkflowStepsParams,) => {
    return [
    `/api/Contracts/GetContractTrackingWorkflowSteps`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetContractTrackingWorkflowStepsQueryOptions = <TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTrackingWorkflowStepsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>> = ({ signal }) => getContractTrackingWorkflowSteps(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractTrackingWorkflowStepsQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>>
export type GetContractTrackingWorkflowStepsQueryError = ErrorType<unknown>


export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractTrackingWorkflowStepsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetContractTrackingWorkflowStepsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractTrackingWorkflowStepsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>> = ({ signal }) => getContractTrackingWorkflowSteps(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetContractTrackingWorkflowStepsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>>
export type GetContractTrackingWorkflowStepsSuspenseQueryError = ErrorType<unknown>


export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: GetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractTrackingWorkflowStepsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetDeadlineUrl = () => {




  return `/api/Contracts/SetDeadline`
}

export const setDeadline = async (setDeadlineRequest: SetDeadlineRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSetDeadlineUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setDeadlineRequest)
  }
);}





export const getSetDeadlineMutationKey = () => ['setDeadline'] as const;

export const getSetDeadlineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,SetDeadlineMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,SetDeadlineMutationVariables, TContext> => {

const mutationKey = getSetDeadlineMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDeadline>>, SetDeadlineMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setDeadline(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDeadlineMutationResult = NonNullable<Awaited<ReturnType<typeof setDeadline>>>
    export type SetDeadlineMutationBody = BodyType<SetDeadlineRequest>
    export type SetDeadlineMutationError = ErrorType<unknown>
    export type SetDeadlineMutationVariables = {data: BodyType<SetDeadlineRequest>}

    export const useSetDeadline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDeadline>>, TError,SetDeadlineMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDeadline>>,
        TError,
        SetDeadlineMutationVariables,
        TContext
      > => {
      return useMutation(getSetDeadlineMutationOptions(options), queryClient);
    }
    export const getStartSigningUrl = () => {




  return `/api/Contracts/StartSigning`
}

export const startSigning = async (startSigningRequest: StartSigningRequest, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<string>(getStartSigningUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startSigningRequest)
  }
);}





export const getStartSigningMutationKey = () => ['startSigning'] as const;

export const getStartSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,StartSigningMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,StartSigningMutationVariables, TContext> => {

const mutationKey = getStartSigningMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSigning>>, StartSigningMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startSigning(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSigningMutationResult = NonNullable<Awaited<ReturnType<typeof startSigning>>>
    export type StartSigningMutationBody = BodyType<StartSigningRequest>
    export type StartSigningMutationError = ErrorType<unknown>
    export type StartSigningMutationVariables = {data: BodyType<StartSigningRequest>}

    export const useStartSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigning>>, TError,StartSigningMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSigning>>,
        TError,
        StartSigningMutationVariables,
        TContext
      > => {
      return useMutation(getStartSigningMutationOptions(options), queryClient);
    }
    export const getStartSigningExternalUrl = () => {




  return `/api/Contracts/StartSigningExternal`
}

export const startSigningExternal = async (startSigningRequest: StartSigningRequest, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<string>(getStartSigningExternalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startSigningRequest)
  }
);}





export const getStartSigningExternalMutationKey = () => ['startSigningExternal'] as const;

export const getStartSigningExternalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,StartSigningExternalMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,StartSigningExternalMutationVariables, TContext> => {

const mutationKey = getStartSigningExternalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSigningExternal>>, StartSigningExternalMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startSigningExternal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSigningExternalMutationResult = NonNullable<Awaited<ReturnType<typeof startSigningExternal>>>
    export type StartSigningExternalMutationBody = BodyType<StartSigningRequest>
    export type StartSigningExternalMutationError = ErrorType<unknown>
    export type StartSigningExternalMutationVariables = {data: BodyType<StartSigningRequest>}

    export const useStartSigningExternal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSigningExternal>>, TError,StartSigningExternalMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSigningExternal>>,
        TError,
        StartSigningExternalMutationVariables,
        TContext
      > => {
      return useMutation(getStartSigningExternalMutationOptions(options), queryClient);
    }
    export const getCompleteSigningUrl = () => {




  return `/api/Contracts/CompleteSigning`
}

export const completeSigning = async (completeSigningRequest: CompleteSigningRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCompleteSigningUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(completeSigningRequest)
  }
);}





export const getCompleteSigningMutationKey = () => ['completeSigning'] as const;

export const getCompleteSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,CompleteSigningMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,CompleteSigningMutationVariables, TContext> => {

const mutationKey = getCompleteSigningMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeSigning>>, CompleteSigningMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  completeSigning(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteSigningMutationResult = NonNullable<Awaited<ReturnType<typeof completeSigning>>>
    export type CompleteSigningMutationBody = BodyType<CompleteSigningRequest>
    export type CompleteSigningMutationError = ErrorType<unknown>
    export type CompleteSigningMutationVariables = {data: BodyType<CompleteSigningRequest>}

    export const useCompleteSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSigning>>, TError,CompleteSigningMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeSigning>>,
        TError,
        CompleteSigningMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteSigningMutationOptions(options), queryClient);
    }
    export const getUploadContractUrl = () => {




  return `/api/Contracts/UploadContract`
}

export const uploadContract = async (uploadContractBody: number, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUploadContractUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadContractBody)
  }
);}





export const getUploadContractMutationKey = () => ['uploadContract'] as const;

export const getUploadContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,UploadContractMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,UploadContractMutationVariables, TContext> => {

const mutationKey = getUploadContractMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadContract>>, UploadContractMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadContract(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadContractMutationResult = NonNullable<Awaited<ReturnType<typeof uploadContract>>>
    export type UploadContractMutationBody = BodyType<number>
    export type UploadContractMutationError = ErrorType<unknown>
    export type UploadContractMutationVariables = {data: BodyType<number>}

    export const useUploadContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadContract>>, TError,UploadContractMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadContract>>,
        TError,
        UploadContractMutationVariables,
        TContext
      > => {
      return useMutation(getUploadContractMutationOptions(options), queryClient);
    }
    export const getSendExternalSignatureMailUrl = () => {




  return `/api/Contracts/SendExternalSignatureMail`
}

export const sendExternalSignatureMail = async (sendExternalSignatureMailBody: number, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getSendExternalSignatureMailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendExternalSignatureMailBody)
  }
);}





export const getSendExternalSignatureMailMutationKey = () => ['sendExternalSignatureMail'] as const;

export const getSendExternalSignatureMailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,SendExternalSignatureMailMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,SendExternalSignatureMailMutationVariables, TContext> => {

const mutationKey = getSendExternalSignatureMailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendExternalSignatureMail>>, SendExternalSignatureMailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendExternalSignatureMail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendExternalSignatureMailMutationResult = NonNullable<Awaited<ReturnType<typeof sendExternalSignatureMail>>>
    export type SendExternalSignatureMailMutationBody = BodyType<number>
    export type SendExternalSignatureMailMutationError = ErrorType<unknown>
    export type SendExternalSignatureMailMutationVariables = {data: BodyType<number>}

    export const useSendExternalSignatureMail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendExternalSignatureMail>>, TError,SendExternalSignatureMailMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendExternalSignatureMail>>,
        TError,
        SendExternalSignatureMailMutationVariables,
        TContext
      > => {
      return useMutation(getSendExternalSignatureMailMutationOptions(options), queryClient);
    }
